import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ColorHelper from "../../helper/ColorHelper";
import "./NotAvailable.css";
export default class NotAvailable extends Component {
  state = {
    userName: "",
    titleColorStyle: null,
    showModal: 0
  };

  componentDidUpdate() {
    if (window["boot"].embedded) {
      if (this.props.dropdownOpen && this.state.showModal === 0) {
        this.setState({ showModal: 1 });
        this.props.minimize();
      }
    } else {
      if (this.state.showModal === 0) {
        this.setState({ showModal: 1 });
      }
    }
  }

  notAvailableModal = () => {
    const { notAvailable: notAvailableLabels } = window["labels"];
    return (
      <Modal isOpen={this.state.showModal} centered={true}>
        <ModalHeader>{notAvailableLabels.title}</ModalHeader>
        <ModalBody>{notAvailableLabels.body}</ModalBody>
        {window["boot"].embedded && (
          <ModalFooter>
            <button
              className="modal-error-btn"
              onClick={() => this.setState({ showModal: false })}
              style={ColorHelper.getInstance().getButtonColorStyle()}
            >
              {notAvailableLabels.btn}
            </button>
          </ModalFooter>
        )}
      </Modal>
    );
  };

  render() {
    return <div>{this.notAvailableModal()}</div>;
  }
}
